<template>
  <router-view/>
  <LocaleSwitcher/>
</template>
<script>
import LocaleSwitcher from "@/components/LocaleSwitcher.vue";
import {mapGetters, mapMutations} from "vuex";

export default {
  components: {
    LocaleSwitcher,
  },
  computed: {
    ...mapGetters({
      _logo: "_logo",
      _color: "_color",
    }),
  },
  methods: {
    ...mapMutations({
      changeLogo: "changeLogo",
      changeColor: "changeColor",
      changeStore: "changeStore",
    }),
  },
  created() {
    let location = window.location.href;

    if (location.search("cancellation.tink.de") !== -1) {
      // https://cancellation.tink.de/ => de - Blue(#1998fa) - logo-tink.svg
      this.$i18n.locale = "de";
      this.changeLogo("logo-tink.svg");
      this.changeColor("btn-primary");
      this.changeStore("de");
    } else if (location.search("cancellation-vattenfall.tink.de") !== -1) {
      // https://cancellation-vattenfall.tink.de/ => de_vf - Yellow(#FFDA00) - logo-vf.svg
      this.$i18n.locale = "de_vf";
      this.changeLogo("logo-vf.svg");
      this.changeColor("btn-custom-yellow");
      this.changeStore("vf");
    } else if (location.search("cancellation-cosmos.tink.de") !== -1) {
      // https://cancellation-cosmos.tink.de/ => de_co - Green(#0f6) - logo-co.svg
      this.$i18n.locale = "de_co";
      this.changeLogo("logo-co.svg");
      this.changeColor("btn-custom-green");
      this.changeStore("co");
    } else if (location.search("cancellation.tink.at") !== -1) {
      // https://cancellation.tink.at/ => de_at - Blue(#1998fa) - logo-tink.svg
      this.$i18n.locale = "de_at";
      this.changeLogo("logo-tink.svg");
      this.changeColor("btn-primary");
      this.changeStore("at");
    } else if (location.search("cancellation-smartthings.tink.de") !== -1) {
      // https://cancellation-smartthings.tink.de/ => de_st - DarkBlue(#1428A0) - logo-st.svg
      this.$i18n.locale = "de_st";
      this.changeLogo("logo-st.svg");
      this.changeColor("btn-custom-dark-blue");
      this.changeStore("st");
    } else if (location.search("cancellation.tink.nl") !== -1) {
      // https://cancellation.tink.nl/ => be_nl - Blue(#1998fa) - logo-tink.svg
      this.$i18n.locale = "be_nl";
      this.changeLogo("logo-tink.svg");
      this.changeColor("btn-primary");
      this.changeStore("nl");
    } else if (location.search("cancellation-vattenfall.tink.nl") !== -1) {
      // https://cancellation-vattenfall.tink.nl/ => be_nl_vf - Yellow(#FFDA00) - logo-vf.svg
      this.$i18n.locale = "be_nl_vf";
      this.changeLogo("logo-vf.svg");
      this.changeColor("btn-custom-yellow");
      this.changeStore("vf-nl");
    } else if (location.search("cancellation.tink.be") !== -1) {
      // https://cancellation.tink.be/ => be - Blue(#1998fa) - logo-tink.svg
      this.$i18n.locale = "be";
      this.changeLogo("logo-tink.svg");
      this.changeColor("btn-primary");
      this.changeStore("be");
    } else if (location.search("cancellation.tink.net") !== -1) {
      // https://cancellation.tink.net/ => se - - Blue(#1998fa) - logo-tink.svg
      this.$i18n.locale = "se";
      this.changeLogo("logo-tink.svg");
      this.changeColor("btn-primary");
      this.changeStore("se")
    } else {
      //default
      this.$i18n.locale = "de";
      this.changeLogo("logo-tink.svg");
      this.changeColor("btn-primary");
      this.changeStore("de");
    }

    /**
     https://cancellation.tink.de/ => de - Blue(#1998fa) - logo-tink.svg
     https://cancellation-vattenfall.tink.de/ => de_vf - Yellow(#FFDA00) - logo-vf.svg
     https://cancellation-cosmos.tink.de/ => de_co - Green(#0f6) - logo-co.svg
     https://cancellation.tink.at/ => de_at - Blue(#1998fa) - logo-tink.svg
     https://cancellation-smartthings.tink.de/ => de_st - DarkBlue(#1428A0) - logo-st.svg

     https://cancellation.tink.nl/ => be_nl - Blue(#1998fa) - logo-tink.svg
     https://cancellation-vattenfall.tink.nl/ => be_nl_vf - Yellow(##FFDA00) - logo-vf.svg
     https://cancellation.tink.be/ => be - Blue(#1998fa) - logo-tink.svg

     https://cancellation.tink.net/ => se - - Blue(#1998fa) - logo-tink.svg
     **/
  },
};
</script>
